import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaH5Props extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

class KuikaH5 extends Component<KuikaH5Props> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <h5 className={classNames("kuika-typography-h5", className)} {...props}>
        {children}
      </h5>
    );
  }
}

export default KuikaH5;
